import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, HostListener, inject } from '@angular/core';
import { OverlayService } from '../../services/overlay.service';

@Component({
    selector: 'app-overlay-outlet',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './overlay-outlet.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverlayOutletComponent {
    private readonly overlay = inject(OverlayService);

    readonly config = this.overlay.config;
    readonly isOpen = this.overlay.isOpen;

    constructor() {
        effect(() => this.toggleBodyScrollLock(this.isOpen()));
    }

    @HostListener('document:keydown.escape')
    onEscape(): void {
        if (this.config()?.closeOnEsc !== false) {
            this.overlay.close();
        }
    }

    onBackdropClick(): void {
        if (this.config()?.closeOnBackdrop !== false) {
            this.overlay.close();
        }
    }

    private toggleBodyScrollLock(locked: boolean): void {
        const body = document.body;
        if (locked) {
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            body.style.overflow = 'hidden';
            body.style.paddingRight = `${scrollbarWidth}px`;
        } else {
            body.style.overflow = '';
            body.style.paddingRight = '';
        }
    }
}
